export default {
  filters: {
    today: 'Hoje',
    yesterday: 'Ontem',
    this_week: 'Esta semana',
    last_week: 'Semana passada',
    this_month: 'Este mês',
    last_month: 'Mês passado',
    all: 'Todos',
  },
};
